import { Setup } from '../types';

export const CURATED_SETUPS: Setup[] = [
  {
    id: 'beginner',
    name: 'Beginner Setup',
    level: 'beginner',
    description: 'Perfect for those just starting their vinyl journey. Simple, affordable, and great sound quality.',
    products: {
      speaker: 'Edifier R1280DB',
      turntable: 'Audio-Technica AT-LP70X',
    },
    totalPrice: 45000,
    image: '/images/beginner-setup.jpg'
  },
  {
    id: 'enthusiast',
    name: 'Enthusiast Setup',
    level: 'enthusiast',
    description: 'For those ready to step up their game. Better components, richer sound, more features.',
    products: {
      speaker: 'Wharfedale Diamond 12.2',
      turntable: 'Rega Planar 1',
      amplifier: 'Denon PMA-600NE',
    },
    totalPrice: 125000,
    image: '/images/enthusiast-setup.jpg'
  },
  {
    id: 'audiophile',
    name: 'Audiophile Setup',
    level: 'audiophile',
    description: 'Premium components for the discerning listener. Exceptional clarity, detail, and musicality.',
    products: {
      speaker: 'KEF Q150',
      turntable: 'Pro-Ject Debut Carbon Evo',
      amplifier: 'Audiolab 6000A',
    },
    totalPrice: 250000,
    image: '/images/audiophile-setup.jpg'
  }
];

export const SETUP_BENEFITS = [
  {
    level: 'beginner',
    benefits: [
      'Easy setup and operation',
      'Built-in amplification',
      'Great value for money',
      'Perfect for small to medium rooms'
    ]
  },
  {
    level: 'enthusiast',
    benefits: [
      'Separate components for better sound',
      'Upgrade path available',
      'Superior build quality',
      'Enhanced detail and dynamics'
    ]
  },
  {
    level: 'audiophile',
    benefits: [
      'Reference-grade components',
      'Exceptional sound reproduction',
      'Premium materials and construction',
      'Professional-level performance'
    ]
  }
];
